// extracted by mini-css-extract-plugin
export default {"anchorWithStickyNavbar":"anchorWithStickyNavbar_loeA","anchorWithHideOnScrollNavbar":"anchorWithHideOnScrollNavbar_emO8"};